import { Component, ElementRef, inject, viewChild } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { AuthService } from '@core/services/auth.services';
import { UserPreferencesService } from '@core/services/user-preferences.service';
import { MenuService } from './app.menu.service';

@Component({
  selector: 'app-sidebar',
  standalone: false,
  templateUrl: './app.sidebar.component.html',
  styleUrls: ['./app.sidebar.component.css']
})
export class AppSidebarComponent {
  menuContainer = viewChild.required<ElementRef>('menuContainer');

  private readonly authService = inject(AuthService);
  protected readonly userPreferences = inject(UserPreferencesService);
  private readonly menuService = inject(MenuService);

  /** Mirrors the user menu popover, for the avatar button's aria-expanded. */
  userMenuOpen = false;

  constructor(
    public layoutService: LayoutService,
    public el: ElementRef
  ) {}

  /** Wide (icons and labels) or the 7rem icon rail; saved to the user's account. */
  toggleMenuWidth(): void {
    // Close any open group first: on the rail an open group is a fly-out, and one carried over from the wide menu
    // would stay open over the page.
    this.menuService.reset();
    this.userPreferences.setMenuCollapsed(!this.userPreferences.menuCollapsed());
  }

  get initials(): string {
    const u = this.authService.currentUser();
    return u ? `${u.firstName?.charAt(0) ?? ''}${u.lastName?.charAt(0) ?? ''}` : '';
  }

  get userName(): string {
    const u = this.authService.currentUser();
    return u ? `${u.firstName} ${u.lastName}` : '';
  }

  get userRole(): string {
    return this.authService.currentUser()?.roleDisplayName ?? '';
  }
}
